import { createSelector } from '@reduxjs/toolkit';

import { allRoles, type Role } from '../../utils/roles';
import { getEntityById } from '../entities/utils';
import type { BaseAppState } from '../types';
import type { RolesDictionary } from './types';

export const getUser = (state: BaseAppState) =>
  getEntityById(state, 'users', state.auth.currentUser?.id);

export const getAllRawRoles = (state: BaseAppState) => {
  if (!state.auth.rawRoles) {
    return allRoles;
  }
  // biome-ignore lint/plugin: API boundary, the generated schema types roles as string[] but they are the app's Role union at runtime.
  return state.auth.rawRoles.objects as Role[];
};

const getUserRoles = (state: BaseAppState) => state.auth.userRoles;

export const selectUserRoles = createSelector(
  [getUser, getAllRawRoles, getUserRoles],
  (user, allRawRoles, userRoles) => {
    const result: RolesDictionary = {};

    const isAdmin = user
      ? Boolean(user.is_admin || user.is_super_admin)
      : false;

    for (const role of allRawRoles) {
      result[role] = isAdmin;
    }

    if (isAdmin) {
      return result;
    }

    return { ...result, ...userRoles };
  },
);
